// 存储适配器 —— 存档层唯一的持久化出入口（架构 §4.1：save 层不认识任何游戏语义）。
// 提供 localStorage 实现 + 内存降级实现；constructStorageAdapter 探测可用性并自动降级（GDD 02 T10 / E4）。

export interface StorageAdapter {
  get(key: string): string | null;
  set(key: string, value: string): void;
  remove(key: string): void;
}

export class LocalStorageAdapter implements StorageAdapter {
  get(key: string): string | null {
    try {
      return window.localStorage.getItem(key);
    } catch {
      return null;
    }
  }

  set(key: string, value: string): void {
    window.localStorage.setItem(key, value);
  }

  remove(key: string): void {
    window.localStorage.removeItem(key);
  }
}

export class MemoryAdapter implements StorageAdapter {
  private readonly store = new Map<string, string>();

  get(key: string): string | null {
    return this.store.get(key) ?? null;
  }

  set(key: string, value: string): void {
    this.store.set(key, value);
  }

  remove(key: string): void {
    this.store.delete(key);
  }
}

// 探测 localStorage 可用性（隐私模式 / 配额满会抛错），失败回退内存态（T10 / E4）。
export function constructStorageAdapter(): StorageAdapter {
  try {
    const probeKey = '__dogtrip_availability_probe__';
    const ls = window.localStorage;
    ls.setItem(probeKey, '1');
    ls.removeItem(probeKey);
    return new LocalStorageAdapter();
  } catch {
    return new MemoryAdapter();
  }
}
